import { CalculatorId } from '../../../lib/calculators/calculator-config';
import type { CalculatorDescription } from '../../../lib/calculators/calculator-description';

export const chiSquareDescription: CalculatorDescription = {
  id: CalculatorId.CHI_SQUARE,
  title: 'Chi-Square Test Calculator',
  metaTitle: 'Online Chi-Square Calculator - Independence Test Tool',
  description: 'Perform chi-square tests for independence and goodness of fit. Analyze categorical data relationships and compare observed vs expected frequencies.',
  metaDescription: 'Calculate chi-square statistics online. Test independence and goodness of fit with our free calculator. Analyze categorical data relationships.',
  howTo: {
    title: 'How to Use the Chi-Square Test Calculator',
    steps: [
      'Enter observed frequencies for each category',
      'Input expected frequencies (or let us calculate them)',
      'Select significance level',
      'View test results and interpretation',
      'Analyze statistical significance'
    ],
    graphic: {
      description: 'A data table for entering observed and expected frequencies, with results showing test statistic and p-value'
    }
  },
  examples: [
    {
      title: 'Survey Independence Test',
      description: 'Testing independence between survey responses and demographic groups',
      dataDescription: 'Survey response data across different demographic categories',
      insights: [
        'Distribution: Categorical data',
        'Tests variable relationships',
        'Shows association strength',
        'Calculates significance'
      ]
    },
    {
      title: 'Genetic Analysis',
      description: 'Testing inheritance patterns in genetic studies',
      dataDescription: 'Phenotype frequency data from genetic crosses',
      insights: [
        'Distribution: Phenotype frequencies',
        'Tests inheritance patterns',
        'Compares observed ratios',
        'Validates hypotheses'
      ]
    }
  ],
  relatedCalculators: [
    CalculatorId.ANOVA,
    CalculatorId.BINOMIAL_DISTRIBUTION,
    CalculatorId.NORMAL_DISTRIBUTION
  ]
}; 